export default (str) => {
    if (typeof str === 'string') {
        return str.toLowerCase();
    }

    return '';
};
